/*
 * @Author: gaobin
 * @Date: 2024-08-10 10:47:32
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-03-19 16:13:41
 * @Description: 设置全局的接口请求方法
 */
import urls from './api/index';
import httpFunc from './uni-request';

const { request, uploadFile } = httpFunc;

const FUNS = {};

Object.keys(urls).forEach((key) => {
  FUNS[key] = (options = {}) => {
    const { httUrlType } = options;
    if (httUrlType === 'upload') {
      const optionsTemp = { ...options };
      delete optionsTemp.httUrlType;
      return uploadFile(urls[key], optionsTemp.data);
    }
    return request(urls[key], options);
  };
});

export default FUNS;
